site.accordion = {
	init: function () {
		var $accordion = $('section.accordion');
		$accordion.each(function () {
			var $this = $(this);
			$('>*:not(:first-child)', $this).wrapAll('<div class="wrap" />');
			$('>:first-child', $this).wrapInner('<a href="#">');
			$('>:first-child a', $this).on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$this.toggleClass('open');

				if ($this.hasClass('open')) {
					site.accordion.addTimeoutClass($this, 'opening');
				}
				else {
					site.accordion.addTimeoutClass($this, 'closing');
				}
			});
		}).on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this);
			if ($this.attr('class').indexOf('open') === -1 && $(e.target).prop('tagName') !== 'A') {
				$this.find('>:first-child a').trigger('click');
			}
		});

		site.accordion.initMaxHeight('section.accordion .wrap');
		$(window).load(function() {
			setTimeout(function() {
				$accordion.addClass('ready');
			}, 1);
		});
	},

	addTimeoutClass: function (element, className, time) {
		time = (time === undefined) ? 400 : time;
		element.addClass(className);
		setTimeout(function () {
			element.removeClass(className);
		}, time);
	},

	initMaxHeight: function (selector) {
		if (!selector || $(selector).length === 0) return;
		$(window).load(function() {
			site.accordion.setHeight(selector);
		});
		$(window).resize(function () {
			site.accordion.setHeight(selector);
		});
	},

	setHeight: function (selector) {
		var $accordion = $('section.accordion');
		$accordion.addClass('open');
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
		$accordion.removeClass('open');
	}
};

$(site.accordion.init());
